import { Routes, Route } from 'react-router-dom';
import Home from './pages/index'
import ExperienciePage from './pages/Experiencie'
import Err from './pages/Err'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/Experiencie" element={<ExperienciePage/>} />
      <Route path="*" element={<Err/>} />
    </Routes>
  );
}

export default App;
